import { ReactElement, useMemo } from 'react';

import CustomSelect, { CustomSelectOption } from 'bloko/blocks/customSelect';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { fromTree } from 'bloko/common/tree/treeCollectionHelper';

import translation from 'src/components/translation';
import { useSelectorNonNullable } from 'src/hooks/useSelector';

const TrlKeys = {
    empty: 'price.tariffField.profRoleGroup.empty',
};

const customSelectWrapperProps = { 'data-qa': 'tariff-field-profRoleGroup' };

const TariffFieldProfRoleGroup: TranslatedComponent<{
    values: string[];
    value?: string;
    onChange: (value: string) => void;
}> = ({ values, value, onChange, trls }) => {
    const allProfRoleGroups = useSelectorNonNullable(({ priceData: { allProfRoleGroups } }) => allProfRoleGroups);
    const dataCollection = useMemo(() => fromTree(allProfRoleGroups!), [allProfRoleGroups]);

    // CustomSelect не переваривает null в children, а getModel не гарантирует наличие
    // результата, так что приходится сначала составлять массив непустых опций.
    const options = values.reduce((result: ReactElement[], id) => {
        const model = dataCollection.getModel(id);
        if (model) {
            result.push(
                <CustomSelectOption key={id} value={id} data-qa={`tariff-field-profRoleGroup_${id}`}>
                    {model.text}
                </CustomSelectOption>
            );
        }
        return result;
    }, []);

    return (
        <CustomSelect
            value={value}
            emptyPlaceholder={trls[TrlKeys.empty]}
            onChange={onChange}
            wrapperProps={customSelectWrapperProps}
        >
            {options}
        </CustomSelect>
    );
};

export default translation(TariffFieldProfRoleGroup);
